import { render } from "./NestedComponents.vue?vue&type=template&id=5bddf0a4&scoped=true"
import script from "./NestedComponents.vue?vue&type=script&lang=js"
export * from "./NestedComponents.vue?vue&type=script&lang=js"

import "./NestedComponents.vue?vue&type=style&index=0&id=5bddf0a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bddf0a4"]])

export default __exports__